<template>
	<toolbar>
		<h2><i class="fa" :class="icon ? icon : 'fa-cog'"></i> {{ title }}</h2>

		<div class="controls">
			<button v-if="showNewButton" class="btn btn-success" v-on:click="newButton">
				<i class="fa fa-plus"></i>
				New
			</button>

			<nav-tabs :tabs="tabs"></nav-tabs>
		</div>
	</toolbar>
</template>

<script>
import NavTabs from "../../layout_fragments/NavTabs"
import Toolbar from "../../layout_fragments/Toolbar"

export default {

	name: 'SettingsToolbar',
	components: {
		Toolbar,
		NavTabs
	},
	props: ["title","showNewButton","icon"],
	data() {
		return {
			tabs: [
				{
					label: "Company Details",
					icon: "fa-pencil-alt",
					path: "/company/details",
					modulePermRequired: ["Settings"]
				},
				{
					label: "Company Settings",
					icon: "fa-cog",
					path: "/company/settings",
					modulePermRequired: ["Settings"]
				},
				{
					label: "Integrations & Apps",
					icon: "fa-puzzle-piece",
					path: "/apps/integrations",
					modulePermRequired: ["Settings"]
				},
				/*{
					label: "Collective Agreements",
					icon: "fa-handshake-o",
					path: "/company/collective-agreements",
					modulePermRequired: ["Users","Expenses","TimeLogs","Jobs"]
				},
				{
					label: "Unions & Collective Agreements",
					icon: "fa-users",
					path: "/company/unions",
					modulePermRequired: ["Settings"]
				},*/
				{
					label: "Permission Templates",
					icon: "fa-lock",
					path: "/permission-templates",
					modulePermRequired: ["Settings"]
				}
			]
		}
	},
	methods: {
		newButton() {
			this.$emit("newButtonClick")
		}
	}

}
</script>